import { render } from "./Dashboard.vue?vue&type=template&id=6693b3ab&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6693b3ab&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=6693b3ab&lang=css"
script.render = render
script.__scopeId = "data-v-6693b3ab"

export default script